import { TripCard } from '../../../redux/trip/trip.types';
import { AuthUser } from '../../../redux/user/user.types';
import { getReactionEmoji } from '../../../utils/reaction-utils';
import './ReactionTooltip.scss';

interface ReactionTooltipProps {
  card: TripCard;
  isVisible: boolean;
  isLarge?: boolean;
  currentUser?: AuthUser | null;
}

function ReactionTooltip({ card, isVisible, isLarge = false, currentUser }: ReactionTooltipProps) {
  if (!isVisible || !card.reactions) {
    return null;
  }

  const getUserDisplayName = (email?: string | null): string => {
    if (!email) {
      return 'Unknown User';
    }
    return email;
  };

  // Convert reactions object to array for rendering
  const userReactions = Object.entries(card.reactions).map(([userId, reaction]) => ({
    userId,
    email: reaction.email,
    reaction: reaction.type,
    timestamp: reaction.timestamp,
  }));

  return (
    <div className={`reaction-tooltip-container${isLarge ? ' large' : ''}`}>
      {userReactions.map(({ userId, email, reaction }) => {
        const isCurrentUser = currentUser?.email === email;
        return (
          <div
            className='reaction-tooltip-item'
            key={userId}
          >
            <div className='user-avatar'>{email?.charAt(0).toUpperCase() || 'U'}</div>
            <div className={`user-info${isCurrentUser ? ' current-user' : ''}`}>
              {getUserDisplayName(email)}
            </div>
            <div className='user-reaction'>{getReactionEmoji(reaction)}</div>
          </div>
        );
      })}
    </div>
  );
}

ReactionTooltip.displayName = 'ReactionTooltip';
export default ReactionTooltip;
